
import { MODULE } from "@/config/modules";
import { checkHasModule } from "@/router";
import Vue from "vue";
import { IBreadCrumb, ISelectItem } from "winfakt-vue-components";
import { LabelLayout } from "../../utils/label-layout/label-layout";
import AppPage from "./Page.vue";
import AppTabs from "./Tabs.vue";
import AppTab from "./Tab.vue";
import AppPageContainer from "../layout-editor/PageContainer.vue";
import { AuthService } from "@/services";
import { downloadBlob } from "@/utils/blob";
import AppUploadJsonModal from "./UploadJsonModal.vue";

export default Vue.extend({
	data(){
		return {
			tab: null as null | string,
			zoomLevelIndex: 4,
			uploadJsonModalOpen: false,
			path: [{
				to: "/settings/label-layouts/", value: this.$ct("components.settings-default.label-layouts")
			}] as IBreadCrumb[],
		};
	},
	props: {
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		},
		name: {
			type: String,
		}
	},
	computed: {
		zoomLevels(): number[] {
			return [25, 50, 75, 85, 100, 150, 200, 400];
		},
		zoomLevel(): number {
			return this.zoomLevels[this.zoomLevelIndex];
		},
		valid():boolean {
			return this.name.trim() != "";
		},
		isDevMode():boolean{
			return AuthService.isDevModeEnabled;
		},
		dropDownItems():ISelectItem<Function>[]{
			let result:ISelectItem<Function>[] = [];
			if (this.isDevMode) {
				result.push({
						text: "Layout downloaden als json",
						icon: "download",
						value: ()=>this.downloadLayoutAsJson()
					},
					{
						text: "Layout laden uit een json",
						icon: "upload",
						value: ()=>this.uploadJsonModalOpen = true
					}
				);
			}

			return result;
		}
	},
	methods: {
		save() {
			this.$emit("save");
		},
		zoomOut() {
			if (this.zoomLevelIndex > 0) {
				this.zoomLevelIndex--;
			}
		},
		zoomIn() {
			if (this.zoomLevelIndex < this.zoomLevels.length - 1) {
				this.zoomLevelIndex++;
			}
		},
		downloadLayoutAsJson(){
			let json = JSON.stringify(this.layout.getJSON());
			let blob = new Blob([json], {type: "application/json"});
			downloadBlob(blob, `${this.name}.json`);
		},
		onNewLayout(layout:any){
			this.layout.setValuesFromJson(layout);
		}
	},
	async created(){
		if (!checkHasModule(MODULE.ETIKETTEN, this.$router)) return;
	},
	components: {
		AppPage,
		AppTabs,
		AppTab,
		AppPageContainer,
		AppUploadJsonModal
	},
	i18nEx: {
		componentPrefix: "components.label-layout-editor"
	}
});
